import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitorLineAddonsFilterPipe } from './visitor-line-addons-filter.pipe';

@NgModule({
  imports: [
   
  ],
  declarations: [
    VisitorLineAddonsFilterPipe
  ],
  exports: [
    VisitorLineAddonsFilterPipe
  ],
})
export class PipeModule {}

